import { BehaviorSubject } from "rxjs";

/**
 * Configuration payload for opening the JSON viewer modal.
 */
export interface JsonViewerConfig {
  /** JSON-compatible data rendered in the viewer. */
  data: unknown;
  /** Optional modal title shown in the JSON viewer header. */
  title?: string;
}

/**
 * Global stream that controls the JSON viewer modal state.
 *
 * - `null` closes the viewer
 * - `JsonViewerConfig` opens/updates the viewer
 */
export const jsonViewerSubject = new BehaviorSubject<JsonViewerConfig | null>(
  null,
);

/**
 * Opens the JSON viewer modal with the provided configuration.
 *
 * @param config Configuration for the viewer content and title.
 */
export const showJsonViewer = (config: JsonViewerConfig) => {
  jsonViewerSubject.next(config);
};

/**
 * Closes the JSON viewer modal.
 */
export const closeJsonViewer = () => {
  jsonViewerSubject.next(null);
};
